export { default } from './PageHotel.vue'
